
/**
 * User Avatar Component
 * 
 * This component displays the avatar image of a user.
 * If no source is provided, it falls back to the current user's avatar from Redux state.
 * If the user has no avatar set, it uses a default avatar image.
 * 
 * @component
 * @param {object} props - Component props
 * @param {string} [props.width="3.75rem"] - Width of the avatar
 * @param {string} [props.height="3.75rem"] - Height of the avatar
 * @param {string} [props.src] - Optional custom image source, overrides the user avatar
 * @returns {JSX.Element} A rendered image element with the user's avatar
 */

import React from 'react'
import { useSelector } from 'react-redux';
import cx from 'classnames';
import _ from 'lodash';
import styles from './styles.module.scss'
const DefaultUserAvatar = '/images/default_user_profile_background.png'


interface UserAvatarProps {
  width?: string;
  height?: string;
  src?: string;
  isEdit?: boolean
  handleClick?: () => void
}


export default function UserAvatar({ width = '3.75rem', height = '3.75rem', src, isEdit, handleClick}: UserAvatarProps) {

  return (
    <div className={cx(styles.userAvatar)} style={{width, height}} onClick={handleClick}>
      <img src={src ? src : DefaultUserAvatar} alt="user" />
      {isEdit && <div className={styles.overlay}> 
         <i className='paperflite-edit'/>
      </div>}
   </div>
  )
}
